var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{style:(_vm.style),attrs:{"size":_vm.size,"indeterminate":"","color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }